// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--LXn6J","image":"_93444fe79c--image--ZJJa9","description":"_93444fe79c--description--klcQi"};